import { render, staticRenderFns } from "./FromPhoneNumberVerificationModal.vue?vue&type=template&id=61250a7c&"
import script from "./FromPhoneNumberVerificationModal.vue?vue&type=script&lang=js&"
export * from "./FromPhoneNumberVerificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports